export class HvacsGroup {
    id: string;
    name: string;
    listOfHvac: Array<string>;
}
